import { render, staticRenderFns } from "./ChildrenDependantsFull.vue?vue&type=template&id=68595649"
import script from "./ChildrenDependantsFull.vue?vue&type=script&lang=js"
export * from "./ChildrenDependantsFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports